import * as React from 'react';
import FinanceProduct from "../../../model/financeProduct/FinanceProduct";
import SortableItemsTable from "../common/SortableItemsTable";

export default class FinanceProductTable extends SortableItemsTable<FinanceProduct> {

	renderHeaderBody() {
		return (
			<React.Fragment>
				<th>Id</th>
				<th>Label</th>
				<th>Description</th>
				<th>Provider</th>
				<th>APR</th>
				<th>Fee percentage</th>
				<th>Status</th>
			</React.Fragment>
		)
	}

	renderRowBody(item: FinanceProduct) {
		return (
			<React.Fragment>
				<td style={{width: "20%"}}>{item.id}</td>
				<td style={{width: "15%"}}>{item.label}</td>
				<td style={{width: "20%"}}>{item.description.getOrElse("-")}</td>
				<td style={{width: "20%"}}>{item.provider}</td>
				<td style={{width: "7%"}}>{item.annualPercentageRate}%</td>
				<td style={{width: "8%"}}>{item.fee.map(fp => `${fp}%`).getOrElse("-")}</td>
				<td style={{width: "10%"}}>{item.disabled ? "Disabled" : "Enabled"}</td>
			</React.Fragment>
		)
	};

	itemToId(item: FinanceProduct): string {
		return item.id;
	}
}
